import { useAuthContentContext } from '@porterin/booking-flow/src/auth/view/contexts/auth-content/AuthContentContext';
import Image from 'next/image';

const AuthCloseCmp = ({ close_modal }: { close_modal: () => void }) => {
  const { backIcon, closeIcon } = useAuthContentContext();
  return (
    <>
      <Image
        src={backIcon.path}
        alt={backIcon.altText}
        width={20}
        height={20}
        className="lg:hidden absolute top-6 left-6"
        onClick={close_modal}
      />
      <Image
        src={closeIcon.path}
        className="absolute top-8 right-8 cursor-pointer max-lg:hidden"
        width={24}
        height={24}
        alt={closeIcon.altText}
        onClick={close_modal}
      />
    </>
  );
};

export default AuthCloseCmp;
